import React, { useRef, useState } from "react";
import { Form, Modal, Button, Image } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { createCalendarEvents } from "../../../http/calendarAPI";

const AddEventModal = ({ show, onHide }) => {
	const [title, setTitle] = useState("");
	const [img, setImg] = useState([null]);
	const [description, setDescription] = useState("");
	const [organizer, setOrganizer] = useState("");
	const [location, setLocation] = useState("");
	const [date, setDate] = useState("");
	const [ps_date, setPS_Date] = useState("");
	const [time, setTime] = useState("");

	const addEvent = () => {
		const formData = new FormData();
		formData.append("title", title);
		formData.append("img", img);
		formData.append("description", description);
		formData.append("organizer", organizer);
		formData.append("location", location);
		formData.append("date", date);
		formData.append("ps_date", ps_date);
		formData.append("time", time);
		createCalendarEvents(formData).then(() => window.location.reload());
	};

	const selectFile = (e) => {
		setImg(e.target.files[0]);
	};

	const modules = {
		toolbar: [
			[{ size: ["small", false, "large", "huge"] }],
			["bold", "italic", "underline", "strike", "blockquote"],
			[{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }, { align: [] }],
			["link", "image"],
			[
				{
					color: [
						"#000000",
						"#e60000",
						"#ff9900",
						"#ffff00",
						"#008a00",
						"#0066cc",
						"#9933ff",
						"#ffffff",
						"#facccc",
						"#ffebcc",
						"#ffffcc",
						"#cce8cc",
						"#cce0f5",
						"#ebd6ff",
						"#bbbbbb",
						"#f06666",
						"#ffc266",
						"#ffff66",
						"#66b966",
						"#66a3e0",
						"#c285ff",
						"#888888",
						"#a10000",
						"#b26b00",
						"#b2b200",
						"#006100",
						"#0047b2",
						"#6b24b2",
						"#444444",
						"#5c0000",
						"#663d00",
						"#666600",
						"#003700",
						"#002966",
						"#3d1466",
						"custom-color",
					],
				},
			],
		],
	};

	const formats = [
		"header",
		"height",
		"bold",
		"italic",
		"underline",
		"strike",
		"blockquote",
		"list",
		"color",
		"bullet",
		"indent",
		"link",
		"image",
		"align",
		"size",
	];
	return (
		<Modal
			show={show}
			onHide={onHide}
			className='add-news-modal border-primary'>
			<Modal.Header
				closeButton={onHide}
				className='bg-primary'
				closeVariant='white'>
				<Modal.Title className='text-white'>Adauga un eveniment</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className='d-flex flex-column justify-content-around'>
					<span className='text-primary  font-2 py-2 ps-1'>Data</span>
					<Form>
						<Form.Group>
							<Form.Control
								type='datetime-local'
								onChange={(data) => {
									let dateData = new Date(data.target.value);
									setDate(
										dateData
											.toLocaleDateString("en-US", {
												day: "2-digit",
												month: "2-digit",
												year: "numeric",
											})
											.toString()
											.split("/")
											.join(".")
									);
									setPS_Date(
										dateData
											.toLocaleDateString("en-US", {
												weekday: "short",
												month: "short",
												day: "numeric",
												year: "numeric",
											})
											.split(",")
											.join("")
									);
									setTime(dateData.toLocaleTimeString("de-DE", { hour: "numeric", minute: "numeric" }));
								}}
							/>
						</Form.Group>
					</Form>
					<span className='text-primary  font-2 py-2 ps-1'>Denumire</span>
					<Form.Control
						aria-label='Title'
						placeholder='Title'
						onChange={(e) => setTitle(e.target.value)}
					/>
					<span className='text-primary  font-2 py-2 ps-1'>Descrieree</span>
					<ReactQuill
						theme='snow'
						value={description}
						modules={modules}
						formats={formats}
						onChange={setDescription}
					/>
					<span className='text-primary  font-2 py-2 ps-1'>Fotografie</span>
					{/* <InputGroup className='mb-3'>
										<InputGroup.Text id='basic-addon'>Logo-ul</InputGroup.Text> */}
					<Form.Control
						type={"file"}
						onChange={selectFile}
						aria-label='PageTitle'
						aria-describedby='basic-addon'
					/>
					<span className='text-primary font-2 py-2 ps-1'>Organizatorul</span>
					<div className='d-flex flex-xl-row flex column align-items-center justify-content-between'>
						<Form.Control
							aria-label='Title'
							value={organizer}
							placeholder='Organizatorul'
							onChange={(e) => setOrganizer(e.target.value)}
						/>
					</div>
					<span className='text-primary font-2 py-2 ps-1'>Locatia</span>
					<Form.Control
						aria-label='Title'
						placeholder='Locatia'
						value={location}
						className='me-4'
						onChange={(e) => setLocation(e.target.value)}
					/>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button
					variant='secondary'
					onClick={onHide}>
					Close
				</Button>
				<Button
					variant='primary'
					onClick={() => {
						onHide();
						addEvent();
					}}>
					Confirm
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default AddEventModal;
